import { render, staticRenderFns } from "./examinationAnswerResult.vue?vue&type=template&id=a15a4482&scoped=true&"
import script from "./examinationAnswerResult.vue?vue&type=script&lang=js&"
export * from "./examinationAnswerResult.vue?vue&type=script&lang=js&"
import style0 from "./examinationAnswerResult.vue?vue&type=style&index=0&id=a15a4482&scoped=true&lang=scss&"
import style1 from "./examinationAnswerResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a4482",
  null
  
)

export default component.exports